require('./bootstrap');

import React from 'react';
import { render } from 'react-dom';
import { createInertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import { Inertia } from '@inertiajs/inertia';
import ReactGA from 'react-ga';

import { UsersRegistrationProvider } from '@/context/UsersRegistration';
import { AppProvider } from './context/App';


if (gaTrackId) ReactGA.initialize(gaTrackId);

Inertia.on('navigate', event => {
    const {component, props} = event.detail.page;
    let {url} = event.detail.page;
    if (component === 'ShowOrder') url += `?order-status=${props.digestStatus}`;
    if (!gaTrackId) return;
    ReactGA.pageview(url);
})

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, App, props }) {
        return render((
            <AppProvider {...props}>
                <UsersRegistrationProvider {...props}>
                    <App {...props} />
                </UsersRegistrationProvider>
            </AppProvider>
        ),
        el
    )},
});

InertiaProgress.init({ color: '#E01880' });
